import { callAuthorizedGraphQLEndpoint } from 'Module/graphQL'

export const getCitySettingsData = async cityId => {
  const query = `query ($cityId:ID!) {
      city(id: $cityId){
        id
        recruitmentOnHold
        name
        timezone
        statusV2
        newcomersMissionsLimit
        cbdRadius
        pickupInformation
        morningCheckInTime
        lunchCheckInTime
        afternoonCheckInTime
        h2hCheckInTimeBefore
        h2hCheckInTimeAfter
        h2hBonusCheckInTimeBefore
        h2hBonusCheckInTimeAfter
        d2dCheckInTimeBefore
        d2dCheckInTimeAfter
        d2dBonusCheckInTimeBefore
        d2dBonusCheckInTimeAfter
        checkinRadius
        payHourly
        recruitmentCalendarId
        eventsCalendarId
        onboardingLocation
        onboardingUrl
        teamLeaderEnabled
        isBaDocumentManagementEnabled
        isOnsiteTrainingEnabled
        country {
          code
        }
        location {
          latitude
          longitude
        }
        spySettings {
          id
          cityId
          hourlyRate
          maxBudgetPerWeek
          travelAllowancePerMission
          travelAllowanceCap
          durationHandToHandMission
          durationLetterboxMission
          durationShift
          missionsPerShift
        }
        baSettings {
          id
          cityId
          baWeeklyMissionsLimit
          tlaWeeklyMissionsLimit
        }
      }
    }`
  return callAuthorizedGraphQLEndpoint(query, { cityId })
}

export const getUsersWithPersonalDataChangeRequest = async ({ cityId }) => {
  const query = `query getUsersWithPersonalDataChangeRequest($cityId:ID!) {
      getUsersWithPersonalDataChangeRequest(cityId: $cityId){
        id
        firstName
        lastName
      }
    }`

  const response = await callAuthorizedGraphQLEndpoint(query, { cityId })

  const {
    data: { getUsersWithPersonalDataChangeRequest },
  } = await response.json()

  return getUsersWithPersonalDataChangeRequest
}
